export function maskAllDigitsExceptLastFour(inputString: string) {
  if (!inputString) {
    return;
  }
  if (inputString.length < 4) {
    return inputString;
  }
  let numToMask = inputString.length - 4;
  let maskedString = 'X'.repeat(numToMask) + inputString.slice(-4);
  return maskedString;
}
